export { default as DocumentDuplicateOutlineIcon } from './DocumentDuplicateOutlineIcon';
